module.exports = __webpack_public_path__ + "media/assets/images/header_movimenta-7b4f1c48b3ba2c309fd6da5b26ad617f.svg";